import { render, staticRenderFns } from "./TravelClaimList.vue?vue&type=template&id=1b5821c2&"
import script from "./TravelClaimList.vue?vue&type=script&lang=js&"
export * from "./TravelClaimList.vue?vue&type=script&lang=js&"
import style0 from "./TravelClaimList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelClaimList.vue"
export default component.exports